// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_iz-0";
export var fulfillmentPanelBody = "_iz-1";